import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-community.tsx
/**
* icon.24.community
*
* Keywords: package, box, delivery, shipping, parcel, cube, three-dimensional, container
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuNSAxMC4zMDlhMSAxIDAgMCAxIDEuNDQ4LS44OTRsNS4wNTMgMi41MjUgNS4wNTMtMi41MjVhMSAxIDAgMCAxIDEuNDQ3Ljg5NHY0LjU3M2MwIC41NjgtLjMyMSAxLjA4Ny0uODMgMS4zNDJsLTUuNDQ3IDIuNzIzYS41LjUgMCAwIDEtLjQ0OCAwTDYuMzMgMTYuMjI0YTEuNSAxLjUgMCAwIDEtLjgzLTEuMzQyem0xLjAwMSA0LjU3M2EuNS41IDAgMCAwIC4yNzYuNDQ3TDExLjUgMTcuNjl2LTQuODhsLTQuOTk5LTIuNXptNS45OTktMi4wNzN2NC44ODFsNC43MjUtMi4zNmEuNS41IDAgMCAwIC4yNzYtLjQ0OHYtNC41NzN6TTEyLjAwMSA1YTIuNSAyLjUgMCAxIDEtLjAwMiA1LjAwMkEyLjUgMi41IDAgMCAxIDEyLjAwMSA1bTAgMWExLjUgMS41IDAgMSAwIDAgMyAxLjUgMS41IDAgMCAwIDAtMyIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2299
*/
const Icon24Community = memo(function Icon24Community(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.5 10.309a1 1 0 0 1 1.448-.894l5.053 2.525 5.053-2.525a1 1 0 0 1 1.447.894v4.573c0 .568-.321 1.087-.83 1.342l-5.447 2.723a.5.5 0 0 1-.448 0L6.33 16.224a1.5 1.5 0 0 1-.83-1.342zm1.001 4.573a.5.5 0 0 0 .276.447L11.5 17.69v-4.88l-4.999-2.5zm5.999-2.073v4.881l4.725-2.36a.5.5 0 0 0 .276-.448v-4.573zM12.001 5a2.5 2.5 0 1 1-.002 5.002A2.5 2.5 0 0 1 12.001 5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.523 9.21a1 1 0 0 1 1.477.88v4.564c0 .55-.302 1.057-.786 1.32l-5.477 2.965a.5.5 0 0 1-.476 0l-5.476-2.965A1.5 1.5 0 0 1 5 14.654V10.09c0-.758.811-1.24 1.478-.88l5.023 2.72zM6 14.654a.5.5 0 0 0 .262.44l4.737 2.566v-4.863L6 10.09zm5.999-1.857v4.863l4.74-2.566a.5.5 0 0 0 .261-.44V10.09zM11.501 5a2.5 2.5 0 1 1-.002 5.002A2.5 2.5 0 0 1 11.501 5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
		})
	});
});
//#endregion
export { Icon24Community };

//# sourceMappingURL=icon-24-community.js.map